import PropTypes from 'prop-types';
import React from 'react';
import { calculatePercentage } from '../../../../lib/utils.js';
import styles from './InitiativeCompletion.module.css';

InitiativeCompletion.propTypes = {
  completionTracked: PropTypes.bool,
  initiativeParticipation: PropTypes.shape({
    leavesCount: PropTypes.number.isRequired,
    leavesCompletedCount: PropTypes.number.isRequired,
  }),
};

InitiativeCompletion.defaultProps = {
  completionTracked: false,
  initiativeParticipation: {
    leavesCount: 0,
    leavesCompletedCount: 0,
  },
};

function InitiativeCompletion({ initiative }) {
  const { completionTracked, participationCount, participationCompletedCount } =
    initiative;

  if (!completionTracked) {
    return <span>—</span>;
  }

  const count = participationCount;
  const completedCount = participationCompletedCount;
  const completionPercentage = calculatePercentage(completedCount, count);
  return (
    <React.Fragment>
      <span>{completionPercentage}%</span>
      <span className={styles.textMuted}>
        {completedCount}/{count}
      </span>
    </React.Fragment>
  );
}

export default InitiativeCompletion;
